<template>
  <div class="plans">
    <m-content
      padding-x="layout"
      :padding-y="12"
      class="_top"
    >
      <div class="_content">
        <page-header
          :title="$t('plans.title')"
          no-padding
          heading="h3"
          class="_header"
        />
        <plan-hint />
        <m-divider />
        <m-btn
          small
          super-light
          :href="$t('plans.helpLink')"
          hide-border
          icon="question-circle"
          target="_blank"
        >
          {{ $t('plans.learnMore') }}
        </m-btn>
      </div>
    </m-content>
    <product-plan-selection />
  </div>
</template>

<script>
import PageHeader from 'shared/components/PageHeader.vue';
import PlanHint from '@/components/plans/PlanHint.vue';
import ProductPlanSelection from '@/components/plans/ProductPlanSelection.vue';

export default {
  name: 'Plans',
  components: { PageHeader, ProductPlanSelection, PlanHint },
};
</script>

<style scoped lang="scss" type="text/scss">
  @import 'shared/assets/scss/padding';

  .plans {
    position: relative;

    ._top {
      position: sticky;
      left: 0;

      ._content {
        width: 100%;
        max-width: 1070px;
        padding-top: 2rem;
        margin: 0 auto;
      }
    }

    ._alert {
      position: sticky;
      left: 0;
      margin-top: 5rem;
      margin-bottom: 5rem;

      @include layoutPaddingX();
    }
  }
</style>
